import React from 'react';
import ErrorPage from './ErrorPage';

interface Props {
    children: React.ReactChild;
}

interface State {
    hasError: boolean;
}

export default class ErrorBoundary extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error: any) {
        console.log(error);
        return { hasError: true };
    }

    componentDidCatch(error: any, errorInfo: any) {
        // TODO log to sentry
    }

    render() {
        if (this.state.hasError) {
            return (
                <ErrorPage>
                    <a
                        href="/"
                        className="mt-6 bg-blue-500 hover:bg-blue-700 text-white font-light py-4 px-6 rounded-full inline-block uppercase shadow-md"
                    >
                        Back To Dashboard
                    </a>
                </ErrorPage>
            );
        }

        return this.props.children;
    }
}
